import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Typography, Card, CardContent, Checkbox, FormControlLabel, CircularProgress } from "@mui/material";
import axios from "axios";
import dayjs from "dayjs"; // For date formatting
import AdminLayout from "./Admin_Layout/AdminLayout";

const ArticleComments = () => {
  const location = useLocation();
  const articleId = location.state?.articleId; // Extract articleId from state

  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!articleId) return;

    const fetchComments = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL + `/api/comments/${articleId}`);
        setComments(response.data.comments);
      } catch (error) {
        console.error("Error fetching comments:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchComments();
  }, [articleId]);

  const handleCheckboxChange = async (commentId, newValue) => {
    try {
      await axios.put(process.env.REACT_APP_API_URL + `/api/comments`, { post: newValue, commentId: commentId });

      // Update state after successful update
      setComments((prev) =>
        prev.map((comment) =>
          comment._id === commentId ? { ...comment, post: newValue } : comment
        )
      );
    } catch (error) {
      console.error("Error updating comment:", error);
    }
  };

  if (!articleId) {
    return <Typography variant="h6" color="error">No article selected.</Typography>;
  }

  if (loading) return <CircularProgress style={{ display: "block", margin: "auto" }} />;

  return (
    <AdminLayout>
      <Container sx={{ mt: 10 }}>
        <Typography variant="h4" gutterBottom>Comments for Article</Typography>
        {comments.length === 0 ? (
          <Typography>No comments available.</Typography>
        ) : (
          comments.map((comment) => (
            <Card key={comment._id} sx={{ mt: 2, p: 0, backgroundColor: comment.post ? "#e8f5e9" : "white", }}>
              <CardContent>
                <Typography variant="body1">{comment.content}</Typography>
                <Typography variant="caption" color="textSecondary">By: {comment.username}</Typography>
                <Typography variant="caption" color="textSecondary" sx={{ ml: 2 }}>
                  {dayjs(comment.createdAt).format("DD MMM YYYY, hh:mm A")}
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={comment.post}
                      onChange={() => handleCheckboxChange(comment._id, !comment.post)}
                      sx={{ ml: 5 }}
                    />
                  }
                  label="Published"
                />
              </CardContent>
            </Card>
          ))
        )}
      </Container>
    </AdminLayout>
  );
};

export default ArticleComments;
